<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar" [attr.data-bs-theme]="appSettings.appSidebarLight ? '' : 'dark'" [ngClass]="{ 
	'app-sidebar-transparent': this.appSidebarTransparent,
	'app-sidebar-grid': this.appSidebarGrid
}">
  <!-- BEGIN scrollbar -->
  <ng-scrollbar class="app-sidebar-content" [ngClass]="{ 'h-100': appSettings.appSidebarFixed }" #sidebarScrollbar
    (scroll)="onScroll($event)">
    <ng-container *ngTemplateOutlet="sidebarNav"></ng-container>
  </ng-scrollbar>
  <!-- END scrollbar -->

  <ng-template #sidebarNav>
    <!-- BEGIN menu -->
    <div class="menu">
      <div class="menu-item menu-profile">
        <div class="menu-profile-cover custom-shadow"></div>
        <div class="menu-profile-info">
          @if(entity){
            <div class="d-flex align-items-center mt-1">
              <div class="flex-grow-1 min-width-0 overflow-hidden">
                <strong class="d-block text-truncate fs-5">{{ entity.code }}</strong>
                <span class="d-block text-truncate" [ngbTooltip]="entity.name" container="body" placement="top">{{ entity.name }}</span>
                <small class="d-block text-truncate">{{ entity.group?.name }}</small>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="menu-header">Navegación</div>

      <!-- render sidebarMenuNav -->
      <ng-template #sidebarMenuNav let-menu="menu">
        @if (menu.img) {
          <div class="menu-icon-img"><img src="{{ menu.img }}" /></div>
        }
        @if (menu.icon) {
          <div class="menu-icon"><i class="{{ menu.icon }}"></i></div>
        }
        @if (menu.title) {
          <div class="menu-text">
            {{ menu.title }}
            @if (menu.label) {
              <span class="menu-label">{{ menu.label }}</span>
            }
          </div>
        }
        @if (menu.badge) {
          <div class="menu-badge">{{ menu.badge }}</div>
        }
        @if (menu.submenu?.length > 0) {
          <div class="menu-caret"></div>
        }
      </ng-template>

      <!-- render sidebarSubMenuNav -->
      <ng-template #sidebarSubMenuNav let-menu="menu">
        @if (menu.title) {
          <div class="menu-text">
            {{ menu.title }}
            @if (menu.highlight) {
              <i class="fa fa-paper-plane text-theme ms-5px"></i>
            }
          </div>
        }
        @if (menu.submenu?.length > 0) {
          <div class="menu-caret"></div>
        }
      </ng-template>

      <!-- sidebar menu -->
      @for(menu of menus;track menu){
        <!-- sidebar menu -->
        <div class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          [ngClass]="{ 'expand': menu.state == 'expand',  'has-sub': menu.submenu?.length > 0, 'd-none': menu.hide }"
          #rla="routerLinkActive">

          <!-- Menu link with submenu -->
          @if (menu.submenu?.length > 0) {
            <a class="menu-link"
              (mouseenter)="showAppSidebarFloatSubMenu(menu.submenu, $event)" (mouseleave)="hideAppSidebarFloatSubMenu()">
              <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
            </a>
          }

          <!-- Menu link without submenu -->
          @if (!menu.submenu?.length) {
            <a class="menu-link" [routerLink]="menu.url">
              <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
            </a>
          }

          <!-- submenu lvl 1 -->
          @if (menu.submenu?.length > 0) {
            <div class="menu-submenu"
              [style.display]="(menu.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu.state == 'collapse') ? 'none' : ''">
              @for (menu1 of menu.submenu; track menu1) {
                <div class="menu-item" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}" #rla1="routerLinkActive">
                  @if (menu1.submenu?.length > 0) {
                    <a class="menu-link"
                      (click)="expandCollapseSubmenu(menu1, menu.submenu, rla1)">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
                    </a>
                  }
                  @if (!menu1.submenu?.length) {
                    <a class="menu-link" [routerLink]="menu1.url">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
                    </a>
                  }
                  <!-- submenu lvl 2 -->
                  @if (menu1.submenu?.length > 0) {
                    <div class="menu-submenu"
                      [style.display]="(menu1.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu1.state == 'collapse') ? 'none' : ''">
                      @for (menu2 of menu1.submenu; track menu2) {
                        <div class="menu-item" routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}" #rla2="routerLinkActive">
                          @if (menu2.submenu?.length > 0) {
                            <a class="menu-link"
                              (click)="expandCollapseSubmenu(menu2, menu1.submenu, rla2)">
                              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                            </a>
                          }
                          @if (!menu2.submenu?.length) {
                            <a class="menu-link" [routerLink]="menu2.url">
                              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                            </a>
                          }
                          <!-- submenu lvl 3 -->
                          @if (menu2.submenu?.length > 0) {
                            <div class="menu-submenu"
                              [style.display]="(menu2.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu2.state == 'collapse') ? 'none' : ''">
                              @for (menu3 of menu2.submenu; track menu3) {
                                <div class="menu-item" routerLinkActive="active"
                                  [routerLinkActiveOptions]="{exact: true}" #rla3="routerLinkActive">
                                  @if (menu3.submenu?.length > 0) {
                                    <a class="menu-link"
                                      (click)="expandCollapseSubmenu(menu3, menu2.submenu, rla3)">
                                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                                    </a>
                                  }
                                  @if (!menu3.submenu?.length) {
                                    <a class="menu-link" [routerLink]="menu3.url">
                                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                                    </a>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>

      }
      <!-- ocultar menu-->
      <div class="menu-item d-flex">
        <a href="javascript:;" class="app-sidebar-minify-btn ms-auto" (click)="toggleAppSidebarMinified()"><i
        class="fa fa-angle-double-left"></i></a>
      </div>

    </div>

  </ng-template>
</div>